export default {
    'project.name': ['„От уста на ухо“… до Internet“','“From one’s mouth to another’s ear”… to Internet“'],
    'bg': ['Български', 'Bulgarian'],
    'en-US': ['Английски', 'English'],
    'Начало': ['Началото', 'The Beginning'],
    'Проектът': ['Проектът', 'The Project'],
    'Пътешествията': ['Пътешествията', 'The Jurneys'],
    'Авторство': ['Авторството', 'The Authorship'],
    'Създателите': ['Създателите', 'The Creators'],
    'Публикации': ['Публикациите', 'The Publications'],
    'Научни форуми': ['Научните форуми', 'The Conferences'],
    'Авторско право': ['Авторското право', 'The Copyright'],
    'Ръкописите': ['Ръкописите', 'The Manuscripts'],
    'Хората разкази': ['Хората разкази', 'The Narativemen'],
    'Предуведомление': ['Предуведомление', 'The Preamble'],
    'Фондацията': ['Фондацията', 'The Fondation'],
}


// WEBPACK FOOTER //
// ./src/modules/Translations/translations.js